/* eslint-disable no-nested-ternary */
import React from 'react'
import { useWizard } from 'react-use-wizard'
import { useTranslation } from 'react-i18next'
import { stepsConfig } from '../../components/ProfileScore/ProfileScore'
import * as s from './HeaderOnboarding.styles'
import useWindowDimensions from '../../../../hooks/useWindowDimensions'

const HeaderOnboarding = () => {
  const { t } = useTranslation(['common', 'talentArea'], { useSuspense: false })
  const { activeStep, stepCount, goToStep } = useWizard()
  const { width } = useWindowDimensions()

  const configTimeline = {
    width:
      width < 400
        ? '250px'
        : width <= 767
        ? '300px'
        : width < 1439
        ? '500px'
        : '500px',
    dotSize: '15px',
    stepCount,
  }

  const dots = new Array(stepCount).fill(0)

  return (
    <s.WrapperHeaderOnboarding config={configTimeline}>
      <div className="timeline">
        {dots.map((el, i) => (
          <s.Dot
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            onClick={() => goToStep(i)}
            className="dot"
            config={configTimeline}
            activeStep={activeStep}
            idx={i}
          >
            <span className="label-step">{stepsConfig(t)[i].label}</span>
          </s.Dot>
        ))}
      </div>
      {/* <h2
        style={{
          margin: '1rem 0',
          fontWeight: '800',
          fontSize: '27px',
          textDecoration: 'underline',
        }}
      >
        {stepsConfig(t)[activeStep].label}
      </h2> */}
    </s.WrapperHeaderOnboarding>
  )
}

export default HeaderOnboarding
